// extracted by mini-css-extract-plugin
module.exports = {"previewHeader":"style_previewHeader__kuKuA"};